// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__3XtHx","breadcrumbs__admin":"Breadcrumbs_breadcrumbs__admin__1lCPn"};